<template>
    <section class="reports traccar_wrp">
        <div v-if="loadings" class="overlay">
            <div class="content content-centered">
                <pulse-loader></pulse-loader>
                <p>Please Wait...</p>
            </div>
        </div>

        <div class="monitoring_wrp">

            <div class="col-md-12 city_dropdown">
                <div v-if="!cityAdmin" class="col-md-4">
                    <div class="row">
                        <!-- <h4>Select City</h4> -->
                        <div class="city_rel_class c-pointer">
                            <multiselect v-model="city" deselect-label="" track-by="value" label="name"
                                placeholder="Select city" :options="cityList" :searchable="true" :allow-empty="false"
                                @select="onCitySelect">
                            </multiselect>
                        </div>
                    </div>
                </div>
                <div>
                </div>
                <button class="btn gradientbt" @click="refreshReportList">
                    Refresh
                </button>
            </div>
            <div class="col-sm-12" style="padding:0px">
                <div class="col-md-3">
                    <div class="dates_left_wrp">
                        <div class="dates_left">
                            <label>Zone</label>
                            <date-picker id="startDate" @input="startDate" v-model="date" lang="en" name="startDate"
                                :not-after="disabledStartDate" :clearable="false" required input-class="form-control"
                                width="100%" valueType="format" :format="'DD-MM-YYYY'"
                                placeholder="Date Filter"></date-picker>
                        </div>

                        <v-server-table @row-click="onRowClick" ref="traccarMonitoringZoneTable" url :limit="5"
                            :columns="columns" :options="options" @loaded="onLoaded">
                            <template slot="beforeBody">
                                <tr v-if="loading" class="VueTables__no-results">
                                    <td class="text-center" colspan="9">
                                        <pulse-loader></pulse-loader>
                                        <!-- <p>Please wait, data is loading.</p> -->
                                    </td>
                                </tr>
                            </template>
                            <template slot="percentage" slot-scope="props">
                                <progress max="100" :value="props.row.percentage" class="progressContainer"></progress>
                                <p class="progressReference">{{ props.row.percentage }} % </p>
                            </template>

                        </v-server-table>
                    </div>
                </div>

                <div class="col-md-6 media_padding">
                    <div class="map-view">
                        <traccarMonitoringMap :key="refreshKey" />
                    </div>
                </div>
                <div class="col-md-3 col-sm-12">
                    <div class="trip_details route_tracking_trip_details">

                        <div class="shedule_date_data">

                            <label>Trip Details </label>

                            <div class="zone_cart_wrp">
                                <div class="shedule_date_inner">
                                    <h5>Zone</h5>
                                    <p>{{ details.zoneName ? details.zoneName : "--" }}</p>
                                </div>
                                <div class="shedule_date_inner">
                                    <h5>Vehicle No</h5>
                                    <p>{{ details.vehicleId ? details.vehicleId.vNumber : "--" }}</p>
                                </div>
                                <div class="shedule_date_inner">
                                    <h5>Device Status</h5>
                                    <p>{{ deviceStatus != undefined ? deviceStatus.status : "--" }}</p>
                                </div>
                                <div class="shedule_date_inner">
                                    <h5>Trip Status</h5>
                                    <p :class="details.tripStatus">{{ details.tripStatus ? details.tripStatus : "--" }}</p>
                                </div>
                            </div>

                            <div class="zone_cart_wrp">
                                <div class="shedule_date_inner">
                                    <h5>Trip Start Time</h5>
                                    <p>{{ details.startTime ? details.startTime : "--" }}</p>
                                </div>

                                <div class="shedule_date_inner">
                                    <h5>Trip End Time</h5>
                                    <p>{{ details.endTime ? details.endTime : "--" }}</p>
                                </div>

                            </div>

                            <div class="zone_cart_wrp driver_zone_wrp">

                                <div class="shedule_date_inner">
                                    <h5>Driver Name</h5>
                                    <p>{{ details.driverFirstName ? details.driverFirstName + ' ' + details.driverLastName :
                                        "--" }}</p>
                                </div>
                                <div class="shedule_date_inner">
                                    <h5>Driver Contact Number</h5>

                                    <p>{{ details.driverContactName ? details.driverContactName : "--" }}</p>
                                </div>
                                <div class="shedule_date_inner">
                                    <h5>Helper Name</h5>
                                    <p>{{ details.helperFirstName ? details.helperFirstName + ' ' + details.helperLastName :
                                        "--" }}</p>
                                </div>
                                <div class="shedule_date_inner">
                                    <h5>Helper Contact Number</h5>
                                    <p>{{ details.helperContactName ? details.helperContactName : "--" }}</p>
                                </div>
                                <div class="shedule_date_inner">
                                    <h5>Total Lines</h5>
                                    <p>{{ details.totalLines != null ? details.totalLines : "--" }}</p>
                                </div>
                                <div class="shedule_date_inner">
                                    <h5>Completed Lines</h5>
                                    <p>{{ details.completedLines != null ? details.completedLines : "--" }}</p>
                                </div>
                                <div class="shedule_date_inner">
                                    <h5>Skipped Lines</h5>
                                    <p>{{ details.totalLines != null ? details.totalLines - details.completedLines : "--" }}
                                    </p>
                                </div>
                                <div class="shedule_date_inner">
                                    <h5>Total Covered Distance [In Zone]</h5>
                                    <p>{{ details.tracarrDistInZone != null ? details.tracarrDistInZone : "--" }}</p>
                                </div>
                                <div class="shedule_date_inner">
                                    <h5>Total Covered Distance</h5>
                                    <p>{{ details.tracarrDistance != null ? details.tracarrDistance : "--" }}</p>
                                </div>
                                <div class="shedule_date_inner">
                                    <h5>Total Time(Hrs)</h5>
                                    <p>{{ details.tracarrTime != null ? details.tracarrTime : "--" }}</p>
                                </div>
                                <div class="shedule_date_inner">
                                    <h5>Total Time [In Zone]</h5>
                                    <p>{{ details.TracarrTimeInZone != null ? details.TracarrTimeInZone : "--" }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </div>

    </section>
</template>

<script>
import traccarMonitoringMap from "../gmapLocation/traccarMonitoringGMap.vue";
import {
    eventBus,
    dutyTrackingService
} from "../../../services";
import dateFormatter from "../../utilities/dateFormate";
import config from "../../../config";
import { date } from "faker/lib/locales/en";

export default {
    name: "traccarMonitoring",
    components: {
        traccarMonitoringMap,
    },
    data() {
        return {
            loadings: false,
            liveLocationData: {},
            disabledStartDate: new Date(),
            refreshKey: 0,
            liveData: [],
            traccarId: null,
            cityList: [],
            traccarUrl: {},
            socket: null,
            details: {},
            datas: [],
            sliderValue: 50,
            startDateIso: this.getFormattedDate(new Date()),
            date: new Date().toLocaleDateString('en-GB', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
            }),
            // date: {},
            loading: false,
            cityAdmin: false,
            driverList: [],
            surveyorList: [],
            traccarMonitoringZoneTable: null,
            parameters: {},
            city: {},
            staffLocationRefresh: null,
            staffLocationRefreshs: null,
            columns: ["areaName", "percentage"],
            startTime: null,
            endTime: null,
            refreshId: null,
            LivePositions: [],
            deviceStatus: {},
            options: {
                pagination: false,
                perPage: false,
                heightlighted: true,
                headings: {
                    areaName: "Zone",
                    percentage: "Percentage",
                },
                filterable: false,
                perPage: 100,
                sortable: [],

                requestFunction: (request) => {
                    this.loading = true;
                    this.parameters.date = this.startDateIso;
                    if (this.parameters.cityId != undefined) {
                        return dutyTrackingService.traccarMonitoring(this.parameters).catch((error) => {
                            console.error("trip.requestFunction-error:", error);
                            this.$snotify.error("Get Zone List", "Error!");
                        });

                    }

                },
                responseAdapter: (response) => {
                    this.loading = false;
                    this.loadings = false;
                    let dataResponse = [];
                    response.data.forEach(el => {
                        let surveyRecord = el
                        surveyRecord["areaName"] = el.areaName ? el.areaName : "--";
                        surveyRecord["percentage"] = el.completedLines != null && el.totalLines > 0 && el.completedLines > 0 && el.totalLines != null ? Math.ceil((el.completedLines / el.totalLines) * 100) : 0;
                        dataResponse.push(surveyRecord)
                    })
                    if (dataResponse[0].tripId != null) {
                        this.getOnZoneDetailsList(dataResponse[0].tripId)
                    }
                    this.datas = dataResponse

                    return {
                        data: dataResponse,
                    };
                },

                customFilters: [{
                    name: "custom_filter",
                    callback: function (row, query) {
                    },
                },],
                uniqueKey: "_id",
            },
        };
    },
    methods: {
        milliseconds(milliseconds) {
            const seconds = Math.floor(milliseconds / 1000);

            if (seconds < 60) {
                return seconds + ' seconds';
            } else if (seconds < 3600) {
                const minutes = Math.floor(seconds / 60);
                return minutes + ' minutes';
            } else {
                const hours = Math.floor(seconds / 3600);
                return hours + ' hours';
            }
        },
        refreshReportList() {
            if (this.refreshId != null) {
                this.getOnZoneDetailsList(this.refreshId)
            }
        },

        getFormattedDate(date) {
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear();
            return `${year}-${month}-${day}`;
        },

        startDate(data) {
            this.clearTripDetails();
            this.refreshKey++;
            this.loadings = true;

            if (data.length > 0) {
                const eventData = data.split("-");
                const startDates = eventData[2] + "-" + eventData[1] + "-" + eventData[0];
                this.startDateIso = startDates
                this.$refs.traccarMonitoringZoneTable.refresh();
            } else {
                this.startDateIso = "";
                this.$refs.traccarMonitoringZoneTable.refresh();
            }

        },
        clearTripDetails() {
            this.details = {},
                this.deviceStatus = {}
        },
        onRowClick(row) {
            this.refreshId = row.row.tripId;
            this.refreshKey++;
            if (row.row.tripId != null) {
                this.getOnZoneDetailsList(row.row.tripId)
            } else {
                this.$snotify.error(
                    "there is no trip associated",
                    "Error!"
                );

            }
        },
        getOnZoneDetailsList(zoneId) {
            this.parameters.zoneId = zoneId;
            return dutyTrackingService
                .traccarMonitoringTripDetails(this.parameters)
                .then((res) => {
                    this.details = res.data[0];
                    this.details['startTime'] = res.data[0].startTime ? dateFormatter(res.data[0].startTime) : '--';
                    this.details['endTime'] = res.data[0].endTime ? dateFormatter(res.data[0].endTime) : '--';
                    this.details['tripStatus'] = res.data[0].tripStatus.charAt(0).toUpperCase() + res.data[0].tripStatus.slice(1);
                    this.details["TracarrTimeInZone"] = this.milliseconds(res.data[0].TracarrTimeInZone);
                    this.traccarId = res.data[0].traccarId;
                    this.liveData = [];
                    this.zoneStartTime = res.data[0].zoneStartTime;
                    this.zoneEndTime = res.data[0].zoneEndTime;
                    if (res.data[0].routeFileGeoLoc != '') {
                        eventBus.$emit("traccarMonitoringrouteFileGeoLoc", this.details.routeFileGeoLoc);
                    }
                    if (res.data[0].vehicleId != '') {
                        eventBus.$emit("traccarMonitoringMapInfoShow", this.details);
                    }

                })
                .catch((error) => {
                    this.loading = false;
                    console.error("tracking.traccarMonitoringTripDetails-error:", error);
                    this.$snotify.error(
                        "Get get On Duty Staff List failed",
                        "Error!"
                    );
                });
        },

        getOnDutyStaffList(cityId) {

            let dutyInfo = [];
            this.surveyorList = [];
            this.driverList = [];
            this.parameters.cityId = cityId

            return dutyTrackingService
                .dutyMonitoring(this.parameters)
                .then((res) => {
                    res.data.response.forEach((element) => {
                        if (element.details.geoLocation.length > 0 && element.role == 'surveyor') {
                            let staff = element;
                            staff["location"] = {};
                            staff["location"]["lat"] = element.details.geoLocation[1] ? element.details.geoLocation[1] : "";
                            staff["location"]["lng"] = element.details.geoLocation[0];
                            staff["lat"] = element.details.geoLocation[1] ? element.details.geoLocation[1] : "";
                            staff["lng"] = element.details.geoLocation[0];
                            dutyInfo.push(staff);
                        }
                    });
                    if (res.data.response != '') {
                        eventBus.$emit("traccarMonitoringGMap", dutyInfo);
                    }
                })
                .catch((error) => {
                    this.loading = false;
                    console.error("tracking.getOnDutySTaffListFunction-error:", error);
                    this.$snotify.error(
                        "Get get On Duty Staff List list failed",
                        "Error!"
                    );
                });
        },

        getCityList() {
            const params = {};
            this.cityList = [];
            let cities = [];
            this.$cityRepository
                .collectionCitysList(params)
                .then((res) => {
                    this.loading = false;
                    if (res.data.response.length > 0) {
                        res.data.response.forEach((element) => {
                            if (element.status === true) {
                                cities.push({
                                    name: element.cityName.length > 25 ?
                                        element.cityName.slice(0, 25) + "..." : element.cityName,
                                    value: element._id,
                                });
                            }
                        });
                        this.cityList = cities;
                        this.city = this.cityList[0];
                        this.parameters.cityId = this.city.value;
                        this.$refs.traccarMonitoringZoneTable.refresh();
                    }
                })
                .catch((error) => {
                    this.loading = false;
                    console.error("cities.requestFunction-error:", error);
                    this.$snotify.error("Get cities list failed", "Error!");
                });
        },
        onLoaded() {
            this.traccarMonitoringZoneTable = this.$refs.traccarMonitoringZoneTable;
        },
        getTraccarUrl() {
            return dutyTrackingService.getTraccarToken().then((response) => {
                const token = response.data.token;
                const getDateTime = new Date().getTime()
                let dataTokenGetDateTine = {
                    token: token,
                    getDateTime: getDateTime
                };
                this.getTraccarUrlSession(dataTokenGetDateTine);
            }).catch((error) => {
                this.loading = false;
                console.error("trackingService-error:", error);
                this.$snotify.error(error.data, "Error!");
            })
        },
        getTraccarUrlSession(data) {
            let dutyInfo = [];
            return dutyTrackingService.traccarMonitoringSession(data).then((response) => {
                const socketUrl = 'wss://' + config.Traccar_URI + 'api/socket';
                this.socket = new WebSocket(socketUrl);

                this.socket.onopen = () => {
                    console.log('WebSocket connection established.');
                },
                    // this.getTraccarUrlDevices();
                    this.socket.onmessage = (event) => {
                        const data = JSON.parse(event.data);
                        if (data.devices != null) {
                            let device = data.devices;
                            let filterDeviceData = device.filter((e) => { return this.traccarId == e.id });
                            this.deviceStatus = filterDeviceData[0];
                        }
                        if (data.positions != null) {
                            this.LivePositions = data.positions;

                        }


                        if (this.LivePositions.length > 0) {
                            let filterData = this.LivePositions.filter((e) => { return this.traccarId == e.deviceId });
                            if (filterData.length) {
                                let liveLocation = {};
                                liveLocation["lat"] = filterData[0].latitude;
                                liveLocation["lng"] = filterData[0].longitude;
                                this.liveLocationData = liveLocation;
                            }
                        }
                    };
                this.socket.onerror = (error) => {
                    console.error('WebSocket error:', error);
                };
            }).catch((error) => {
                this.loading = false;
                console.error("trackingService-error:", error);
                this.$snotify.error(error.data.message, "Error!");

            })
        },
        onCitySelect(city) {
            this.parameters.cityId = city.value
            this.$refs.traccarMonitoringZoneTable.refresh()
        },
        dutyTrackingOnInit() {
            if (!this.$store.state.auth.user.cityId) {
                this.getCityList();
                this.getTraccarUrl();
            } else {
                this.cityAdmin = true;
                let cityId = this.$store.state.auth.user.cityId._id;
                this.parameters.cityId = cityId
                this.getTraccarUrl();
            }
        }
    },
    computed: {
        getPercentage() {
            return this.sliderValue;
        },

    },
    mounted() {

        this.staffLocationRefresh = setInterval(() => {
            if (this.liveLocationData != '') {
                eventBus.$emit("traccarMonitoringGMapSocket", this.liveLocationData);
            }
        }, 30000);


        this.staffLocationRefreshs = setInterval(() => {
            const today = new Date().toISOString().split('T')[0];
            if (this.startDateIso == today) {
                this.refreshReportList();
            }
        }, 30000);
        this.dutyTrackingOnInit();
    },

    created() {
        this.dutyTrackingOnInit()
    },
    beforeDestroy() {
        clearInterval(this.staffLocationRefresh)
        clearInterval(this.staffLocationRefreshs)
        this.socket.close();
    }
};
</script>

<style>
.test-table {
    margin-left: 80px;
}

.subcattable table {
    margin-left: 0px;
}

.subcattable table td,
.subcattable table th {
    border: 1px solid #f4f4f4;
}

.subcattable table tr:nth-of-type(odd) {
    background-color: #f9f9f9;
}

.subcattable table tr:hover {
    background-color: #5e9cfe29 !important;
}

.edit_del_btn {
    border: 0;
    background-color: transparent;
    color: #35A2FE;
}

.subcattable table tr td:last-child {
    width: 200px;
}

.city_dropdown {
    display: flex;
    justify-content: space-between;
    margin: 20px 0px;
}

.city_rel_class {
    width: 150%;
}

.monitor {
    overflow: auto;
    height: 368px
}

.driver-data .monitor {
    height: 290px !important;
}

.monitor table {
    margin: 0;
    position: relative;
    top: -2px
}

.monitor table thead {
    position: sticky;
    top: -1px;
}

.table-body-details {
    overflow: auto;
    height: 290px !important;
}

.monitoring_wrp .vue-map-container {
    height: calc(100vh - 295px) !important;
}

.monitoring_wrp .table-responsive {
    height: calc(100vh - 342px);
}

@media(max-width:1199px) {
    .monitoring_wrp .vue-map-container {
        height: calc(100vh - 320px) !important;
    }
}

@media(max-width:991px) {
    .monitoring_wrp {
        height: calc(100vh - 235px);
        overflow: auto;
    }

    .monitor table {
        width: 100%;
    }
}

@media(max-width:767px) {
    .city_dropdown {
        margin: 10px 0px;
        flex-direction: column-reverse;
    }

    .city_rel_class {
        width: 100% !important;
        margin-top: 10px;
    }
}

.trip_details .shedule_date_inner {
    flex: 100%;
    display: flex;
    /* / flex-direction: column; / */
    border-radius: 5px;
    padding: 0px 10px;
    justify-content: space-between;
}

.trip_details .shedule_date_inner h5 {
    color: #000;
    flex: 0 0 50%;

}

.trip_details .shedule_date_inner p {
    font-weight: normal;
    color: #000;
    margin-bottom: 2px;
    text-align: right;
    font-size: 13px;
    font-weight: 700;

}

.trip_details .shedule_date_data {
    margin-top: 0px;
    border-radius: 5px;
}

.trip_details .shedule_date_data label {
    font-size: 18px;
    margin-bottom: 15px;
    width: 100%;
}

/* 
.trip_details {
    overflow: auto;
    height: calc(100vh - 235px);
} */
.dates_left_wrp .dates_left label {
    color: #fff;
    font-size: 18px;
    margin-bottom: 10px;
}

.zone_cart_wrp {
    width: 100%;
    background: #fff;
    margin-bottom: 20px;
    padding: 10px;
}

.zone_cart_wrp h2 {
    color: #000;
}

.traccar_wrp .table-responsive {
    background: #fff;
    margin-top: 15px;
}

.traccar_wrp .table-responsive table {
    margin-left: 0px;
}

.traccar_wrp .VueTables__limit {
    display: none;
}

.dates_left_wrp {
    padding: 10px;
    border-radius: 5px;
}

.zone_cart_wrp.driver_zone_wrp {
    height: calc(100vh - 548px);
    overflow: auto;
}

.zone_cart_wrp.driver_zone_wrp::-webkit-scrollbar {
    width: 5px;
}

.zone_cart_wrp.driver_zone_wrp::-webkit-scrollbar-track {
    background: #f1f1f1;
}

/* Handle */
.zone_cart_wrp.driver_zone_wrp::-webkit-scrollbar-thumb {
    background: #888;
}


.map-view {
    box-shadow: 2px 2px 2px 2px rgba(0, 0, 0, 0.105);
    border: 5px solid #35A2FE;
    border-radius: 5px;

}

.dates_left_wrp p {
    margin-bottom: 0px;
}

.progressContainer {
    height: 26px;
    width: 210px;
    -webkit-appearance: none;
    appearance: none;
    background-color: #eee;
    border-radius: 2px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25) inset
}

.progressReference {
    margin-top: -37px;
    padding: 10px;
}

.dates_left_wrp table tr td {
    font-size: 12px;
}

.overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    /* Semi-transparent background */
    backdrop-filter: blur(1px);
    /* Apply blur effect to the background content */
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
    /* Make sure it's on top of other content */
}


.content-centered {
    text-align: center;
}

.traccar_wrp .table-responsive thead {
    z-index: 0;
}

/* .snotifyToast{
   z-index: 3;
} */
.gradientbt:focus {
    color: #fff !important;
    background: #35A2FE;
    border-color:#35A2FE ;
    outline: none;
}
.gradientbt:active:focus, .gradientbt:focus {
    outline: 0px auto -webkit-focus-ring-color;
    outline-offset: 0px;
}

.route_tracking_trip_details {
    width: 100%;
}

.route_tracking_trip_details .shedule_date_data {
    min-width: auto !important;
}

.media_padding {
    padding-left: 0px;
    padding-right: 0px;
}

@media(max-width:767px) {
    .media_padding {
        padding-left: 15px;
        padding-right: 15px;
    }

    .route_tracking_trip_details {
        margin-top: 20px;
    }
}

.monitoring_wrp .table-bordered {
    min-width: auto !important;
}</style>



// WEBPACK FOOTER //
// traccarMonitoring.vue?27fb2435